// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { GlobalVariables } from '../../../global-variables';


// @Injectable({
//   providedIn: 'root'
// })
// export class CompanyService {

//   // 🔥 Change this to your API base
//   private baseUrl = `${GlobalVariables.vcardURL}companies`;

//   constructor(private http: HttpClient) {}

//   // ✅ GET ALL ROLES
//   getByOwner(ownerId:string): Observable<any> {
//     return this.http.get<any>(`${this.baseUrl}/by-owner/${ownerId}`);
//   }

  

// uploadLogo(formData: FormData) {
//   return this.http.post(
//     `${this.baseUrl}/companies/upload-logo`,
//     formData
//   );
// }

//   // ✅ GET ROLE BY ID
//   getById(id: string): Observable<any> {
//     return this.http.get<any>(`${this.baseUrl}/${id}`);
//   }

//   // ✅ CREATE ROLE
//   create(data: any): Observable<any> {
//     /*
//       Expected payload:
//       {
//         name: "Manager",
//         level: 2,
//         permissions: [] (optional future use)
//       }
//     */
//     return this.http.post<any>(this.baseUrl, data);
//   }

//   // ✅ UPDATE ROLE
//   update(id: string, data: any): Observable<any> {
//     return this.http.put<any>(`${this.baseUrl}/${id}`, data);
//   }

//   // ✅ DELETE ROLE
//   delete(id: string): Observable<any> {
//     return this.http.delete<any>(`${this.baseUrl}/${id}`);
//   }

//   // 🔥 OPTIONAL: GET ROLES BY LEVEL (useful for hierarchy filtering)
//   getByLevel(level: number): Observable<any> {
//     return this.http.get<any>(`${this.baseUrl}?level=${level}`);
//   }
// }


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariables } from '../../../global-variables';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private baseUrl = `${GlobalVariables.vcardURL}companies`;

  constructor(
    private http: HttpClient
  ) {}

  getByOwner(ownerId: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/by-owner/${ownerId}`
    );
  }

  getById(id: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${id}`
    );
  }

  create(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl,
      data
    );
  }

  update(id: string, data: any): Observable<any> {
    return this.http.patch<any>(
      `${this.baseUrl}/${id}`,
      data
    );
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(
      `${this.baseUrl}/${id}`
    );
  }

  getByLevel(level: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}?level=${level}`
    );
  }

  /*
   * Upload Company Logo
   */
  uploadLogo(formData: FormData): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/upload-logo`,
      formData
    );
  }

  /*
   * Upload Background Image
   */
  uploadBackground(formData: FormData): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/upload-background`,
      formData
    );
  }

  checkVCardUser(id:string) {
     return this.http.get<any>(
      `${this.baseUrl}/by-owner/${id}`
    );
  }

  addVcardUser(formData: any) : Observable<any> {
    return this.http.post<any>(
      `${GlobalVariables.vcardURL}/auth/register-full`,
      formData
    );
  }

  addVcardRegistration(formData:any):Observable<any> {
    return this.http.post<any>(`${GlobalVariables.vcardURL}/auth/register-scanfluence`, formData);
  }
}